import { TExperiment } from '../../types/experiment';

const defaultState: TExperiment[] = [];

export function experimentsReducer(state: TExperiment[] = defaultState) {
  return state;
}
